import { ErrorHandler, inject, Provider } from '@angular/core';
import { Router } from '@angular/router';
import {
    AngularPlugin,
    ApplicationinsightsAngularpluginErrorService,
} from '@microsoft/applicationinsights-angularplugin-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

import { WolfConfig } from '../wolf-environment';
import { AnalyticsService } from './analytics.service';

export function provideAnalytics(): Provider[] {
    return [
        {
            provide: ErrorHandler,
            useClass: ApplicationinsightsAngularpluginErrorService,
        },
        {
            provide: ApplicationInsights,
            useFactory: () => {
                const router = inject(Router);
                const config = inject(WolfConfig);
                const angularPlugin = new AngularPlugin();
                const appInsights = new ApplicationInsights({
                    config: {
                        instrumentationKey: config.instrumentationKey,
                        extensions: [angularPlugin],
                        extensionConfig: {
                            [angularPlugin.identifier]: {
                                router,
                                errorServices: [new ErrorHandler()],
                            },
                        },
                    },
                });
                appInsights.loadAppInsights();
                return appInsights;
            },
        },
        AnalyticsService,
    ];
}
